(() => {
  const selector = '.product-card-js';
  const pending = new Set();

  const initSlider = (slider) => {
    if (!slider.isConnected || slider.swiper) return;
    observer?.unobserve(slider);
    pending.delete(slider);
    new Swiper(slider, {
      slidesPerView: 1,
      speed: 650,
      spaceBetween: 2,
      loop: slider.dataset.loop === 'true',
      navigation: {
        nextEl: slider.querySelector('.swiper-button-next-1'),
        prevEl: slider.querySelector('.swiper-button-prev-1'),
      },
      pagination: {
        el: slider.querySelector('.product-card-pagination'),
        clickable: true,
      },
    });
    slider.classList.add('slider_started');
  };

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) initSlider(entry.target);
        });
      }, { rootMargin: '200px' })
    : null;

  window.initProductCardSliders = (root = document) => {
    // Filtering removes cards before a new grid arrives.
    pending.forEach(slider => {
      if (!slider.isConnected) {
        observer?.unobserve(slider);
        pending.delete(slider);
      }
    });
    root.querySelectorAll(selector).forEach(slider => {
      if (slider.swiper || pending.has(slider)) return;
      if (observer) {
        pending.add(slider);
        observer.observe(slider);
      } else {
        initSlider(slider);
      }
    });
  };

  // Keyboard focus and pointer interaction also activate a card immediately.
  ['focusin', 'pointerover'].forEach(type => {
    document.addEventListener(type, event => {
      const slider = event.target.closest('.card--product')?.querySelector(selector);
      if (slider) initSlider(slider);
    });
  });

  document.addEventListener('pointermove', event => {
    if (event.pointerType !== 'mouse') return;
    const card = event.target.closest('.card--product_cursor');
    if (!card) return;
    const rect = card.getBoundingClientRect();
    card.querySelectorAll('.product__cursor').forEach(cursor => {
      cursor.classList.toggle('active', !event.target.closest('.link, .swiper-pagination'));
      cursor.dataset.type = event.clientX - rect.left < rect.width / 2 ? 'prev' : 'next';
      cursor.style.transform = `translate(${event.clientX - rect.left - 12}px, ${event.clientY - rect.top - 12}px)`;
      const button = cursor.parentElement.querySelector('.swiper-button-disabled');
      cursor.style.opacity = button ? '0.5' : '';
    });
  });
  document.addEventListener('pointerout', event => {
    const card = event.target.closest('.card--product_cursor');
    if (card && !card.contains(event.relatedTarget)) {
      card.querySelectorAll('.product__cursor').forEach(cursor => cursor.classList.remove('active'));
    }
  });

  document.addEventListener('shopify:section:load', event => window.initProductCardSliders(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll(selector).forEach(slider => {
      observer?.unobserve(slider);
      pending.delete(slider);
      slider.swiper?.destroy();
    });
  });
  window.initProductCardSliders();
})();
